function OpenInboxButton() {
  return null;
}

export default OpenInboxButton;
